import { render, staticRenderFns } from "./ProductReveal.vue?vue&type=template&id=6b86fee3"
import script from "./ProductReveal.vue?vue&type=script&lang=js"
export * from "./ProductReveal.vue?vue&type=script&lang=js"
import style0 from "./ProductReveal.vue?vue&type=style&index=0&id=6b86fee3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports